import {Theme} from './types';
import consts from './styleConsts';

const theme: Theme = {
  fontFamily: {
    base: consts.FONT_FAMILY_BASE,
    code: consts.FONT_FAMILY_CODE
  },
  fontSize: {
    base: 14,
    small: 12,
    large: 16
  },
  color: {
    primary: consts.COLOR_PRIMARY,
    secondary: consts.COLOR_SECONDARY
  },
  globalHeader: {
    backgroundColor: consts.GLOBAL_HEADER__BACKGROUND_COLOR,
    height: consts.GLOBAL_HEADER__HEIGHT,
    paddingX: consts.GLOBAL_HEADER__PADDING_X,
    enableShadow: consts.GLOBAL_HEADER__ENABLE_SHADOW,
    shadowOffsetY: consts.GLOBAL_HEADER__SHADOW_OFFSET_Y,
    shadowBlurRadius: consts.GLOBAL_HEADER__SHADOW_BLUR_RADIUS,
    shadowColor: consts.GLOBAL_HEADER__SHADOW_COLOR,
    zIndex: consts.GLOBAL_HEADER__ZINDEX
  },
  globalFooter: {
    backgroundColor: consts.GLOBAL_FOOTER__BACKGROUND_COLOR,
    height: consts.GLOBAL_FOOTER__HEIGHT,
    paddingX: consts.GLOBAL_FOOTER__PADDING_X
  },
  globalSider: {
    backgroundColor: consts.GLOBAL_SIDER__BACKGROUND_COLOR,
    width: consts.GLOBAL_SIDER__WIDTH,
    zIndex: consts.GLOBAL_SIDER__ZINDEX
  },
  textField: {
    height: {
      base: 36,
      small: 20,
      large: 55
    },
    paddingX: {
      base: 14,
      small: 10,
      large: 18
    },
    paddingXWithIconOffset: {
      base: 30,
      small: 24,
      large: 42
    },
    multilinePaddingY: {
      base: 7,
      small: 5,
      large: 9
    },
    fontSize: {
      base: 14,
      small: 12,
      large: 16
    },
    iconSize: {
      base: 16,
      small: 14,
      large: 24
    },
    borderRadius: 3,
    borderColor: {
      base: '#C5CAD4',
      hover: '#7C4EF6',
      focus: '#7C4EF6'
    }
  },
  tableBorderWidth: consts.TABLE__BORDER_WIDTH,
  tableBorderColor: consts.TABLE__BORDER_COLOR,
  tableBorderRadius: {
    base: consts.TABLE__BORDER_RADIUS_BASE,
    small: consts.TABLE__BORDER_RADIUS_SMALL,
    large: consts.TABLE__BORDER_RADIUS_LARGE
  },
  steps: {
    vertical: {
      paddingY: 10,
      stepHeightCollapsed: 80
    },
    head: {
      fontFamily: consts.FONT_FAMILY_BASE,
      fontSize: 24,
      fontWeight: 300,
      spaceAround: 10,
      borderWidth: 1,
      pending: {
        color: '#C5CAD4',
        textColor: '#C5CAD4'
      },
      processing: {
        color: '#7C4EF6',
        textColor: '#7C4EF6'
      },
      finished: {
        color: '#FEC34C',
        textColor: '#FEC34C'
      },
      errored: {
        color: 'red',
        textColor: 'red'
      }
    },
    circle: {
      size: 53,
      filled: false,
      filledFinished: false
    },
    dot: {
      size: 20
    },
    lineWidth: 1,
    lineStyle: 'solid',
    lineColor: {
      empty: '#C5CAD4',
      filled: '#FEC34C'
    }
  }
};

export default theme;



// WEBPACK FOOTER //
// ./src/theme/theme.ts